
import { getAuthToken } from "../../services/authService-sighup";


export const getAssetHeaders = async () => {
    const token = await getAuthToken();
    if (!token) {
      throw new Error("Failed to retrieve authentication token.");
    }
  
    return {
      Authorization: `Bearer ${token}`,
      "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSCRIPTION_KEY_METADATA ?? "",
      Product: "AMP-UI",
    };
  };
  
export const getOutageHeaders = async () => {
  const token = await getAuthToken();
  if (!token) {
    throw new Error("Failed to retrieve authentication token.");
  }

  return {
    Authorization: `Bearer ${token}`,
    "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSCRIPTION_KEY_OUTAGES ?? "",
    Product: "AMP-UI",
  };
};
